// extracted by mini-css-extract-plugin
module.exports = {"popupBackground":"popup_popupBackground__1LtUY","popupActive":"popup_popupActive__2Vl-c"};